<template>
  <div class="remote-generic-form">
    <div v-if="dtoFormat && !errorRegistro && !cargandoDto && !cargandoRegistro" style="width: 100%">
      <slot>
        <FormularioWizard :fields="dtoFormat"
                          :id="id"
                          :error-messages="erroresValidacion"
                          :ignore-fields="camposIgnorados"
                          v-model="formModel"
                          :disabled="disabled"
                          :readonly="readonly"
                          :pages-name="pages"
                          :headers="headers"
                          :field-with-hint-text="fieldWithHintText"
                          :select-actions="selectActions"
                          @appendEvent="appendEvent($event)"
        ></FormularioWizard>
      </slot>
    </div>
    <ErrorMessage
        v-else-if="errorDto"
        @refresh="getDtoFormat()"
        message="Error al obtener el formulario. Revise su conexión e inténtelo nuevamente"></ErrorMessage>
    <ErrorMessage
        v-else-if="errorRegistro"
        @refresh="getRegistro()"
        message="Error al obtener los datos. Revise su conexión e inténtelo nuevamente"></ErrorMessage>
    <v-skeleton-loader
        ref="skeleton"
        v-if="cargandoDto || cargandoRegistro"
        type="card"
        class="mx-auto"
    ></v-skeleton-loader>
  </div>

</template>
<script>
import FormularioWizard from '@/views/formularios/FormularioWizard';
import RemoteGenericForm from '@/components/RemoteGenericForm';

export default {
  name: 'FormularioForm',
  components: { FormularioWizard, RemoteGenericForm, },
  extends: RemoteGenericForm,
};
</script>

<style scoped>

</style>
